import React, {  useEffect } from 'react';
import Landing from "../src/Containers/landing/landing"
import Marksentry from "../src/Containers/MarksEntry/marksEntry"
import Invalidcopies from "../src/Containers/invalidcopies/invalidcopies"
import Extracopies from "../src/Containers/extracopies/extracopies"
import Batchtable from "../src/Containers/batch/batchtable"
import Awlprint from "../src/Containers/awlprint"
import Bill from "../src/Containers/bill/bill"
import Billprint from "../src/Containers/bill/billprint"
import Profile from "../src/Containers/profile/profile"
import Main from "../src/Containers/main/main"
import './App.css';

//import asyncComponent from '../src/hoc/asyncComponent/asyncComponent';
import {connect} from 'react-redux';
import * as actions from './store/actions/index';
import {Route, Switch, Redirect} from 'react-router-dom';
//import Logout from '../src/Containers/Auth/logout/logout';

//const asyncAuth = asyncComponent(() => {
//  return import('./Containers/Auth/Auth')
//});
function App(props) {
  useEffect(() => {
    props.onTryAutoSignup();
  });
  let routes = (
      <Switch>
        <Route path="/" exact component={Landing} />
        <Redirect to="/" />
    </Switch>
      );
  if (props.isAuth)
    routes = (
    <Switch>
      <Route path="/Main" exact component={Main} />
      <Route path="/Batchtable" exact component={Batchtable} />
      <Route path="/Marksentry" exact component={Marksentry} />
      <Route path="/Invalidcopies" exact component={Invalidcopies} />
      <Route path="/Extracopies" exact component={Extracopies} />
      <Route path="/AwlPrint" exact component={Awlprint} />
      <Route path="/BillPrint" exact component={Billprint} />
      <Route path="/Bill" exact component={Bill} />
      <Route path="/Profile" exact component={Profile} />
      <Route path="/" exact component={Landing} />
      <Redirect to="/" />
  </Switch>
    )

    return (
    <div >
      {routes}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    isAuth:state.auth.token !== null,
    isAdmin:state.auth.isAdmin
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onTryAutoSignup:() => dispatch(actions.authCheckState())
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(App);
